import React from "react";
import { cn } from "../../../lib/utils";
import HierarchyPath from "./HierarchyPath";
import { Outlet, useLocation, useParams } from "react-router-dom";
import { resolveCaseRouteIdFromPath, WORKBENCH_CHILD_NAV_LABELS, WorkbenchChildRouteIds } from "../../caselayout/config/caseRoutes";

const WorkbenchLayout: React.FC = ({
}) => {

  const { id: caseId } = useParams<{ id: string }>();
  const location = useLocation();

  if (!caseId) return null;

  const activeRouteId = resolveCaseRouteIdFromPath(location.pathname, caseId);

  if(!activeRouteId){
    return null;
  }

  return (
    <div className="w-full h-full overflow-auto bg-[#F3F4F6]">
      <div className={cn("max-w-8xl mx-6 mt-6 mb-4")}>
        <div className="mb-4">
          <HierarchyPath
            segments={[
              { label: "Investigation Workbench" },
              {
                label: WORKBENCH_CHILD_NAV_LABELS[activeRouteId as WorkbenchChildRouteIds],
                active: true,
              },
            ]}
          />
        </div>

        <Outlet />
      </div>
    </div>
  );
};

export default WorkbenchLayout;